import { AuthGuard } from '../../auth.guard';
import { Feature } from '../../models/feature';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
 
  showNavBar: boolean = false;
  featureList: Feature[] = [];
  
  constructor(private _guard: AuthGuard){
    
              this.featureList=[
              {description:'home', routepath:'/dashboard', icon:'fa fa-home'},
              {description:'users', routepath:'/users', icon:'fa fa-user'},
              {description:'doctors', routepath:'/doctors', icon:'fa fa-user-md'},
              {description:'hospitals', routepath:'/hospitals', icon:'fa fa-hospital-o'},
              {description:'invoices', routepath:'/invoices', icon:'fa fa-file-text'},
              {description:'payments', routepath:'/payments', icon:'fa fa-credit-card'},
              {description:'reports', routepath:'/reports', icon:'fa fa-folder-open-o'}]
    
    
  }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/components/navigation/navigation.component.ts